import textServices from 'services/text-services'
import LogoStrip from 'views/home/v3/components/LogoStrip'
import { NEIGHBARS_ASSETS } from '../constants'

interface ComingNextSectionProps {
  showCta: boolean
  onCtaClick: () => void
}

const ComingNextSection = ({ showCta, onCtaClick }: ComingNextSectionProps) => {
  return (
    <section className="neighbars__coming-next">
      <h2 className="neighbars__coming-next-title">
        {textServices.findByText('neighbars/comingNext/title', 'Lo mejor está por venir')}
      </h2>
      <p className="neighbars__coming-next-description">
        {textServices.findByText(
          'neighbars/comingNext/description',
          'Próximamente nuevas experiencias exclusivas para miembros My Heineken.'
        )}
      </p>
      {showCta && (
        <button type="button" className="home-v3__button neighbars__coming-next-cta" onClick={onCtaClick}>
          {textServices.findByText('neighbars/comingNext/cta', '¡Quiero ser parte!')}
        </button>
      )}
      {/* Mobile keeps the baked strip; >=1024px swaps to the shared LogoStrip */}
      <div className="neighbars__coming-next-logos">
        <img src={`${NEIGHBARS_ASSETS}/home-membresias-logos-mobile.webp`} alt="My Heineken | Neighbars" />
      </div>
      <LogoStrip className="home-v3__franja--membership" />
    </section>
  )
}

export default ComingNextSection
